<template>
    <div>
        <div class="food-buttom-box">
            <div class="food-bottom-left">
                <div class="foodAvatar">
                    <img :src="item.avatar || require('@/assets/avatar-img.png')" alt="">
                    <span>{{item.nickname}}</span>
                </div>
                <div class="foodDescription">{{item.reason}}</div>
            </div>
            <div class="food-bottom-right" v-if="item && item.video_img!=''">
                <a :href="item.video_url" target="_blank">
                    <div class="food-bottom-right-img-box">
                        <img :src="item.video_img" class="food-bottom-right-img" alt="">
                    </div>
                    <div class="food-bottom-right-play-box">
                        <div class="food-bottom-right-play"></div>
                    </div>
                </a>
            </div>
        </div>
        <div class="food-buttom-box view">
            <a class="see-poster" v-if="item&&item.report_url" :href="item.report_url" target="_blank">查看报告详情></a>
            <a class="see-video" v-if="item&&item.video_url" :href="item.video_url" target="_blank">查看试用视频></a>
<!--            <router-link class="see-poster" v-if="item && !item.report_url && !item.video_url" :to="`/detail/` + itemid" href="#查看详情">-->
<!--                敬请期待~-->
<!--            </router-link>-->
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ReportContent',
        props: ['item', 'itemid'],
        data() {
            return {}
        },
        created() {

        },
        computed: {},
        mounted() {

        },
        methods: {
            initSwiper() {
                if (this.swiperObj) return;
                this.swiperObj = new Swiper('.swiper-container-report', {
                    loop: true,
                    // slidesPerView: 1,
                    spaceBetween: 0,
                    slidesPerView: 'auto',
                    speed: 600,
                    pagination: {
                        el: '.swiper-pagination-report',
                    },
                });
            }
        },
    }
</script>

<style scoped>
    .food-buttom-box {
        display: flex;
        align-items: stretch;
        margin: 0 .12rem;
        padding-bottom: .075rem;
    }

    .food-buttom-box.view {
        width: 100%;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0;
    }

    .food-bottom-left {
        flex: 1;
        margin-right:.12rem;
    }

    .food-bottom-left.view {
        flex: 1;
        margin: 0;
    }

    .food-bottom-right {
        position: relative;
        margin-top: 4.5vw;
    }

    .food-bottom-right.view {
        position: relative;
        margin: 0;
    }

    .food-bottom-right-img-box {
        width: 1.2rem;
        height: 1.2rem;
    }

    .food-bottom-right-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .food-bottom-right-play-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .4);
    }

    .food-bottom-right-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: .45rem;
        height: .45rem;
        background-color: rgba(255, 255, 255, .8);
        -webkit-mask-box-image: url('~@/assets/home/video-player.png');

    }

    .foodAvatar {
        display: flex;
        align-items: center;
        font-size: 2.7vw;
        width: 100%;
        font-weight: 600;
        color: #000000;
        line-height: 4.7vw;
        margin: 4.5vw 0 0 0;

    }

    .foodAvatar img {
        width: 4.7vw;
        margin-right: 0.8vw;
        border-radius: 50%;
    }

    .foodAvatar span {
        width: 16vw;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

    }

    .foodDescription {
        max-width: 100%;
        margin-top: 1vw;
        white-space: pre-wrap;
        text-overflow: ellipsis;
        font-size: 2.1vw;
        color: #000000;
        line-height: 3.3vw;
        height: 9.8vw;
        word-break: break-all;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .foodDetails {
        color: #1757D9;
        font-size: 0.22rem;
        text-decoration: underline;
    }

    .see-poster {
        background: url('~@/assets/home/chakananniu3.png') top center/cover no-repeat;
        background-size: 100% 100%;
        padding: 0 .15rem;
        font-size: 2vw;
        color: #fff;
    }

    .see-video {
        background: url('~@/assets/home/view-video.png') top center/cover no-repeat;
        background-size: 100% 100%;
        padding: 0 .15rem;
        font-size: 2vw;
        color: #fff;
    }


</style>
